"use client";

import { redirect } from "next/navigation";
import { useClientSideAuth } from "@/hooks";

export default function SettingsRedirect() {
    useClientSideAuth();
    redirect(`/account-settings/extensions`);
}
